
window.useOpenCFTurnstileChecked = async () => {
  return await new Promise((resolve, reject) => {
    const req = {
      detail: {
        successCallback: (token) => {
          resolve(token)
        },
        errorCallback: (code) => {
          const err = {
            message: 'Turnstile recaptcha fail',
            code: code || 0
          }
          reject(err)
        }
      }
    }
    document.dispatchEvent(new CustomEvent('useOpenCFTurnstileChecked', req))
  })
}
/**
 * @description cf 验证
 * @param {*} el
 */

// 测试test
// const sitekey = '1x00000000000000000000AA' // 总是成功
// const sitekey = '2x00000000000000000000AB' // 总是阻塞
// const sitekey = '1x00000000000000000000BB' // 总是过去
// const sitekey = '2x00000000000000000000BB' // 总是阻塞
// const sitekey = '3x00000000000000000000FF' // 强制互动

window.useCFTurnstileChecked = (language, cb) => {
  return new Promise((resolve, reject) => {
    const render = function () {
      cb && cb()
      window.turnstile.render('#cf-turnstile', {
        sitekey: '0x4AAAAAAAQ0xNN_STcUteE5',
        theme: 'light',
        size: 'normal', // compact normal
        language: language === 'zh' ? 'zh-tw' : language || 'en',
        callback: function (token) {
          resolve(token)
        },
        'error-callback': function (err) {
          reject(err)
        }
      })
    }
    if (window.turnstile) {
      render()
    } else {
      window.onloadTurnstileCallback = render
      const script = document.createElement('script')
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback'
      script.onerror = function (err) {
        reject(err)
      }
      document.body.appendChild(script)
    }
  })
}


/*
 * @description 获取app相关信息
 * ADLINK_ID
 * ADYEN_3DINFO
 * APP_BUILDVERSION
 * APP_CURRENCY_INFO
 * APP_VERSION
 * COUNTRY
 * DEVICE_ID
 * EMAIL
 * HOME_POSITION
 * LANGUAGE
 * LAST_URL
 * PAGE_POSITION
 * PATPAT_EXPERIMENTS
 * PIN
 * PLATFORM
 * SETTING_COUNTRY
 * SITE_ABB
 * TIMEZONE
 * TIMEZONE_NAME
 * USER_ID
 * USER_TOKEN
 * IPHONE_STATEBAR_HEIGHT
 * IPHONE_BOTTOM_SAFE_HEIGHT
 */

function getIsClient() {
  return typeof window !== 'undefined' && typeof window === 'object'
}
window.getAppInfo = (PatPat = {}, language = 'en') => {
  let nav = {}
  if (getIsClient() && window.navigator) {
    // 客户端
    nav = window.navigator
  }
  const u = getPatPatKey(nav, 'userAgent', '')
  const platform = getPatPatKey(PatPat, 'PLATFORM', 'wap')
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 || platform === 'android' // android
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || platform === 'ios' // ios
  const hostEnv = {
    isIos: isiOS,
    isAndroid: isAndroid,
    appNavVersion: getPatPatKey(nav, 'appVersion', ''),
    pin: getPatPatKey(PatPat, 'PIN', ''),
    token: getPatPatKey(PatPat, 'USER_TOKEN', ''),
    userLevel: getPatPatKey(PatPat, 'USER_MEMBER_LEVEL', 0), // 9.8版本补充会员等级信息
    userId: getPatPatKey(PatPat, 'USER_ID', ''),
    shopifyUserId: getPatPatKey(PatPat, 'SHOPIFY_USER_ID', ''),
    country: getPatPatKey(PatPat, 'SETTING_COUNTRY', ''), // 国家名称
    siteAbb: getPatPatKey(PatPat, 'SITE_ABB', ''), // 站点
    currencyInfo: getPatPatKey(PatPat, 'APP_CURRENCY_INFO', ''), // 货币信息
    appVersion: getPatPatKey(PatPat, 'APP_VERSION', ''),
    isLogin: false,
    experiments: getPatPatKey(PatPat, 'PATPAT_EXPERIMENTS', '') || '', // app实验参数
    language: getPatPatKey(PatPat, 'LANGUAGE', language), // app语言
    deviceID: getPatPatKey(PatPat, 'DEVICE_ID', ''), // 设备ID
    adlinkId: getPatPatKey(PatPat, 'ADLINK_ID', ''), // adlk_id
    adyen3Dinfo: getPatPatKey(PatPat, 'ADYEN_3DINFO', '') || '',
    appBuildVersion: getPatPatKey(PatPat, 'APP_BUILDVERSION', ''),
    countryCode: getPatPatKey(PatPat, 'COUNTRY', ''), // 国家码
    email: getPatPatKey(PatPat, 'EMAIL', ''),
    phone: getPatPatKey(PatPat, 'PHONE', ''),
    homePosition: getPatPatKey(PatPat, 'HOME_POSITION', '') || '',
    lastUrl: getPatPatKey(PatPat, 'LAST_URL', '') || '',
    pagePosition: getPatPatKey(PatPat, 'PAGE_POSITION', '') || '',
    lastTid: getPatPatKey(PatPat, 'LAST_TID', '') || '',
    lastPagePositionId: getPatPatKey(PatPat, 'LAST_PAGE_POSITION_ID', '') || '', // -- 新规则埋点坑位
    lastPagePositionContent: getPatPatKey(PatPat, 'LAST_PAGE_POSITION_CONTENT', '') || '', // -- 新规则埋点坑位内容
    rootPagePositionId: getPatPatKey(PatPat, 'ROOT_PAGE_POSITION_ID', '') || '', //  -- 新规则埋点坑位， 内容可复用HOME_POSITION_CONTENT
    platform: platform, // ios | android | wap
    timeZone: decodeURIComponent(getPatPatKey(PatPat, 'TIMEZONE', '')), // GTM+8
    timeZoneName: decodeURIComponent(getPatPatKey(PatPat, 'TIMEZONE_NAME', '')), // Asia/Shanghai
    isReminded: getPatPatKey(PatPat, 'SYSTEM_PUSH_STATUS', ''),
    statusBarHeight: getPatPatKey(PatPat, 'IPHONESTATEBARHEIGHT', 0), // ios app状态栏高度， 安卓暂时没有
    TID: getPatPatKey(PatPat, 'TID', ''),
    isFromApp: platform === 'ios' || platform === 'android',
    homePositionContent: getPatPatKey(PatPat, 'HOME_POSITION_CONTENT', '') || '', // app 6.9才支持这两个字段
    pagePositionContent: getPatPatKey(PatPat, 'PAGE_POSITION_CONTENT', '') || '',
    appVersionNumber: 0, // app数字版本号
    sessionId: getPatPatKey(PatPat, 'SESSION_ID', ''), // app的session_id,7.5版本才支持
    pageViewTime: getPatPatKey(PatPat, 'PAGE_VIEW_TIME', 0), // app的page_view_time,7.5版本才支持
    iphoneStatebarHeight: getPatPatKey(PatPat, 'IPHONE_STATEBAR_HEIGHT', 0), // iphone 状态栏高度 7.7.6版本才支持 （之前的不准，ios开发说是写死的，现在这个是动态获取的）
    iphoneBottomSafeHeight: getPatPatKey(PatPat, 'IPHONE_BOTTOM_SAFE_HEIGHT', 0), // iphone 底部安全区域高度 7.7.6版本才支持
    shutdownIntercom: getPatPatKey(PatPat, 'IS_CLEAR_INTERCOM_SESSION', 0) // 是否需要销毁intercom聊天
  }
  try {
    hostEnv.language = hostEnv.language.includes('-') ? hostEnv.language.split('-')[0] : hostEnv.language
    hostEnv.isLogin = hostEnv.token && hostEnv.token !== 'guest'
    hostEnv.statusBarHeight = hostEnv.statusBarHeight - 0
    if (hostEnv.currencyInfo) {
      try {
        if (typeof hostEnv.currencyInfo === 'string') {
          hostEnv.currencyInfo = JSON.parse(hostEnv.currencyInfo)
        }
        if (hostEnv.currencyInfo.currencyCode) {
          hostEnv.currencyCode = hostEnv.currencyInfo.currencyCode
        }
      } catch (e) {
        console.log('APP_CURRENCY_INFO json parse error')
      }
    }
    hostEnv.appVersionNumber = Number(String(hostEnv.appVersion).split('.').reduce((item1, item2, index) => index === 1 ? (item1 + '.' + item2) : (item1 + item2)))
    // 若app小版本号大于9之后请使用下面这个版本拆解，小版本号将在0-99之间，之前的版本判断记得改动
    // hostEnv.appVersionNumber = Number(String('7.12.2').split('.').reduce((item1, item2, index) => index === 1 ? (item1 + '.' + String(item2).padStart(2, 0)) : (item1 + String(item2).padStart(2, 0))))
    if (hostEnv.appVersionNumber === 7.8) {
      // 7.8游客token不为'guest',加上邮箱判断。安卓游客邮箱为'null', ios为''
      hostEnv.isLogin = hostEnv.isLogin && hostEnv.userId && (hostEnv.email ? hostEnv.email !== 'null' : false)
    }
    if (hostEnv.appVersionNumber >= 7.9) {
      // 7.9.0 这个版本开始注入IS_LOGON这个字段, 7.8.0 版本判断用户是否登陆无效因为该版本开始游客也有user_id 和 user_token
      hostEnv.isLogin = !!getPatPatKey(PatPat, 'IS_LOGIN', false) // ios:  0 | 1  android: true | false
    }
    return hostEnv
  } catch (err) {
    console.log(err)
    return hostEnv
  }
}

const getPatPatKey = (o, k, df) => {
  if (getIsClient() && window.PatPat && typeof window.PatPat === 'object') {
    // 安卓客户端只能在 window.PatPat 对象读取数据，否则报错，请不要将 window.PatPat 指派到其他对象在取值
    if (window.PatPat) {
      if (window.PatPat[k]) {
        if (typeof window.PatPat[k] === 'function') {
          try {
            return window.PatPat[k]()
          } catch (err) {
            return df
          }
        } else {
          return window.PatPat[k]
        }
      } else {
        return df
      }
    }
  }
  if (o && typeof o === 'object' && Object.prototype.hasOwnProperty.call(o, k)) {
    const v = o[k]
    if (typeof v === 'function') {
      return v()
    } else {
      return v
    }
  }
  return df
}

const findPlatform = () => {
  const appPatPat = window.PatPat
  if (appPatPat) {
    if (typeof appPatPat.PLATFORM === 'function') {
      return appPatPat.PLATFORM()
    } else if (appPatPat.PLATFORM) {
      return appPatPat.PLATFORM
    }
  } else {
    return 'wap'
  }
}

/**
 * 调用触发原生App某个函数
 * @param {String} functionName 函数名称 eg: share login refresh_cart
 * @param {Object} params
 * @param {Function} callback
 * @param {Object} other
 */
const onNativeFunction = (functionName, params, callback, other) => {
  window.nativeCallback = callback
  let typeObj = {
    method: functionName,
    content: params
  }
  if (other) {
    typeObj = Object.assign({}, typeObj, other)
  }
  if (findPlatform() == 'ios') {
    if (window.webkit && window.webkit.messageHandlers.jsCallWithCallback) {
      window.webkit.messageHandlers.jsCallWithCallback.postMessage(JSON.stringify(typeObj))
    }
  } else if (findPlatform() == 'android') {
    window.PatPat.jsCallWithCallback(JSON.stringify(typeObj))
  } else {
  }
}



/**
 * Drawer Submenu - 二级、三级菜单交互逻辑
 * 处理二级菜单的抽屉式导航和三级菜单的手风琴展开
 */

class DrawerSubmenu {
  constructor() {
    this.init();
  }

  init() {
    // 等待DOM加载完成
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.bindEvents());
    } else {
      this.bindEvents();
    }
  }

  bindEvents() {
    // 使用事件委托处理所有submenu相关的点击事件
    document.addEventListener('click', (e) => {
      const target = e.target.closest('[data-submenu-toggle]');
      if (target) {
        this.handleSubmenuToggle(e, target);
      }
    });

    // 处理返回按钮
    document.addEventListener('click', (e) => {
      const backBtn = e.target.closest('.drawer-submenu__back-btn');
      if (backBtn) {
        this.handleBackButton(e);
      }
    });

    // 处理关闭按钮
    document.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('.drawer-submenu__close-btn');
      if (closeBtn) {
        this.handleCloseButton(e);
      }
    });
  }

  handleSubmenuToggle(e, target) {
    e.preventDefault();

    const subList = target.nextElementSibling;
    if (!subList || !subList.classList.contains('drawer-submenu__sub-list')) {
      return;
    }

    const isExpanded = target.getAttribute('aria-expanded') === 'true';
    
    if (isExpanded) {
      this.collapseSubmenu(target, subList);
    } else {
      this.expandSubmenu(target, subList);
    }
  }

  expandSubmenu(toggle, subList) {
    // 设置展开状态
    toggle.setAttribute('aria-expanded', 'true');
    subList.classList.add('expanded');
    
    // 计算实际高度并应用
    setTimeout(() => {
      const scrollHeight = subList.scrollHeight;
      subList.style.maxHeight = scrollHeight + 'px';
    }, 10);
  }

  collapseSubmenu(toggle, subList) {
    // 设置收起状态
    toggle.setAttribute('aria-expanded', 'false');
    subList.classList.remove('expanded');
    subList.style.maxHeight = '0px';
  }

  handleBackButton(e) {
    e.preventDefault();
    
    // 收起所有展开的三级菜单
    const currentSubmenu = e.target.closest('.drawer-submenu');
    if (currentSubmenu) {
      const expandedToggles = currentSubmenu.querySelectorAll('[aria-expanded="true"]');
      expandedToggles.forEach(toggle => {
        const subList = toggle.nextElementSibling;
        if (subList) {
          this.collapseSubmenu(toggle, subList);
        }
      });
    }

    // 隐藏当前二级菜单
    const submenuWrapper = e.target.closest('.drawer-menu__submenu-wrapper');
    if (submenuWrapper) {
      submenuWrapper.classList.remove('visible');
      submenuWrapper.setAttribute('aria-hidden', 'true');
    }

    // 触发drawer-menu的返回逻辑
    const backEvent = new CustomEvent('drawer-submenu:back');
    document.dispatchEvent(backEvent);
  }

  handleCloseButton(e) {
    e.preventDefault();
    
    // 触发drawer-menu的关闭逻辑
    const closeEvent = new CustomEvent('drawer-submenu:close');
    document.dispatchEvent(closeEvent);
  }

  // 初始化所有submenu的状态 - 默认展开三级菜单
  initializeState() {
    const submenuToggles = document.querySelectorAll('[data-submenu-toggle]');
    submenuToggles.forEach(toggle => {
      const subList = toggle.nextElementSibling;
      
      // 默认展开状态
      toggle.setAttribute('aria-expanded', 'true');
      
      if (subList && subList.classList.contains('drawer-submenu__sub-list')) {
        subList.classList.add('expanded');
        // 计算实际高度并设置
        setTimeout(() => {
          const scrollHeight = subList.scrollHeight;
          subList.style.maxHeight = scrollHeight + 'px';
        }, 10);
      }
    });
  }

  // 重置所有submenu状态 - 默认展开三级菜单
  resetState() {
    const submenuToggles = document.querySelectorAll('[data-submenu-toggle]');
    submenuToggles.forEach(toggle => {
      const subList = toggle.nextElementSibling;
      
      toggle.setAttribute('aria-expanded', 'true');
      
      if (subList && subList.classList.contains('drawer-submenu__sub-list')) {
        subList.classList.add('expanded');
        // 计算实际高度并设置
        setTimeout(() => {
          const scrollHeight = subList.scrollHeight;
          subList.style.maxHeight = scrollHeight + 'px';
        }, 10);
      }
    });
  }
}

// 初始化DrawerSubmenu
const drawerSubmenu = new DrawerSubmenu();

// 暴露到全局作用域，供其他脚本使用
window.DrawerSubmenu = drawerSubmenu; 


/**
 * Global Country & Language Selector API
 *
 * Provides a simple interface to show/hide the country and language selector popup
 * from anywhere in your Shopify theme.
 *
 * @version 1.0.0
 */

(function (window) {
  'use strict'

  // Global API object
  const CountryLanguageSelector = {

    /**
     * Show the country/language selector popup
     * @param {Object} options - Optional configuration
     * @param {Function} options.onShown - Callback when popup is shown
     * @param {Function} options.onChanged - Callback when selection changes
     */
    show: function (options = {}) {
      const event = new CustomEvent('showCountryLanguageSelector', {
        detail: options
      })
      document.dispatchEvent(event)

      // Set up one-time listeners for callbacks
      if (options.onShown) {
        document.addEventListener('countryLanguageSelectorShown', options.onShown, { once: true })
      }
      if (options.onChanged) {
        document.addEventListener('countryLanguageChanged', options.onChanged, { once: true })
      }
    },

    /**
     * Hide the country/language selector popup
     * @param {Object} options - Optional configuration
     * @param {Function} options.onHidden - Callback when popup is hidden
     */
    hide: function (options = {}) {
      const event = new CustomEvent('hideCountryLanguageSelector', {
        detail: options
      })
      document.dispatchEvent(event)

      if (options.onHidden) {
        document.addEventListener('countryLanguageSelectorHidden', options.onHidden, { once: true })
      }
    },

    /**
     * Toggle the country/language selector popup
     * @param {Object} options - Optional configuration
     */
    toggle: function (options = {}) {
      const event = new CustomEvent('toggleCountryLanguageSelector', {
        detail: options
      })
      document.dispatchEvent(event)
    },


    /**
     * Check if popup is currently visible
     * @returns {boolean} True if popup is visible
     */
    isVisible: function () {
      const selector = document.getElementById('global-country-language-selector')
      return selector && selector.classList.contains('active')
    },

    /**
     * Initialize the selector (called automatically)
     * @private
     */
    init: function () {
      // Listen for DOM content loaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.setupAutoTriggers.bind(this))
      } else {
        this.setupAutoTriggers()
      }
    },

    /**
     * Setup automatic triggers based on data attributes
     * @private
     */
    setupAutoTriggers: function () {
      // Find elements with data-country-selector-trigger attribute
      const triggers = document.querySelectorAll('[data-country-selector-trigger]')

      triggers.forEach(trigger => {
        const action = trigger.getAttribute('data-country-selector-trigger') || 'toggle'

        trigger.addEventListener('click', (e) => {
          e.preventDefault()

          switch (action) {
          case 'show':
            this.show()
            break
          case 'hide':
            this.hide()
            break
          case 'toggle':
          default:
            this.toggle()
            break
          }
        })
      })

      // Auto-show functionality
      const autoShow = document.querySelector('[data-country-selector-auto-show]')
      if (autoShow && !localStorage.getItem('country-selector-auto-shown')) {
        const delay = parseInt(autoShow.getAttribute('data-country-selector-auto-show')) || 0

        setTimeout(() => {
          this.show()
          localStorage.setItem('country-selector-auto-shown', 'true')
        }, delay)
      }
    }
  }

  // Auto-initialize
  CountryLanguageSelector.init()

  // Expose to global scope
  window.CountryLanguageSelector = CountryLanguageSelector

  // Also expose as shorter alias
  window.CLS = CountryLanguageSelector
})(window)


